import BigNumber from 'bignumber.js';
import ZestImage from 'images/zest.png';

import { assets } from '../constants/assets';
import DefIcon from '../images/def_icon.svg';
import StxIcon from '../images/stacks-stx-logo.svg';
import { SafeFtBalance, Transaction } from '../store';

// TODO check this interface usages. Seems like we don't use it that much anymore so maybe remove it
// outGoingBalance and incomingBalance balance not used anywhere (check again)
export interface AssetListFromBalancesType {
  symbol: string;
  address: string;
  balance: string;
  totalBalance: string;
  isLess: boolean;
  decimals: number;
  tokenName: string;
  incomingBalance: string;
  tokenIcon: any;
  outGoingBalance: string;
  ref: string;
  isSTX20?: boolean;
}

export const getAssetListFromBalances = (
  ftBalances: SafeFtBalance[],
  transactions: Transaction[]
): AssetListFromBalancesType[] => {
  return ftBalances.map((safeBalance) => {
    let incomingBalance = new BigNumber(0);
    let outGoingBalance = new BigNumber(0);
    for (const tx of transactions) {
      // TODO: count transactions here too, now it's empty
      if (tx.selectType === 1 && tx.currentAmount !== tx.totalAmount) {
        incomingBalance = incomingBalance.plus(new BigNumber(tx.totalAmount ?? 0));
      }
      if (tx.selectType === 2 && tx.currentAmount !== tx.totalAmount) {
        outGoingBalance = outGoingBalance.plus(new BigNumber(tx.totalAmount ?? 0));
      }
    }

    const getIcon = () => {
      if (safeBalance.asset.symbol === 'STX') {
        return safeBalance.asset.symbol === 'STX' ? StxIcon : DefIcon;
      }
      if (safeBalance.asset.symbol === 'zsBTC') {
        return ZestImage;
      }
      const cachedImage = assets.find((asset) => asset.symbol === safeBalance.asset.symbol)?.image;

      return (
        safeBalance.asset.metadata?.image_thumbnail_uri ||
        safeBalance.asset.metadata?.image_uri ||
        cachedImage ||
        DefIcon
      );
    };

    const tokenIcon = getIcon();

    return {
      tokenIcon,
      ref: safeBalance.asset.ref,
      symbol: safeBalance.asset.symbol,
      tokenName: safeBalance.asset.ref,
      balance: new BigNumber(safeBalance.balance).shiftedBy(-safeBalance.asset.decimals).toString(),
      totalBalance: `$${new BigNumber(safeBalance.balance)
        .shiftedBy(-safeBalance.asset.decimals)
        .toString()}`, // TODO: add icon and change balance to $
      incomingBalance: incomingBalance.toString(),
      outGoingBalance: outGoingBalance.toString(),
      isLess: false,
      decimals: safeBalance.asset.decimals,
      address: safeBalance.asset.address,
    };
  });
};
